"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const base_models_1 = require("@integration/base-models");
const PropositionProduct_1 = tslib_1.__importDefault(require("../../propositions/PropositionProduct"));
class MakeOfferResponseOfferProduct extends PropositionProduct_1.default {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        example: 'G_H_B',
        description: `Describes the type of installation (G or E).
    The second part describes if it is a household (H) or not (M).
    The last part describes the type of contract (Basis, Basis Duurzaam), this is not the same as 'keuzeTarief'.`,
    }),
    tslib_1.__metadata("design:type", String)
], MakeOfferResponseOfferProduct.prototype, "commodityProduct", void 0);
exports.default = MakeOfferResponseOfferProduct;
